import watch from 'redux-watch';

class ShopMarkerClickerCtrl {

    constructor($scope, storeServ) {
        this.$scope = $scope;
        this.storeServ = storeServ;

        this.ngOnInit();
    }

    ngOnInit() {
        this.subscribeToStore();
        
        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    subscribeToStore() {
        let watchTriggerClickOnMarker = watch(this.storeServ.getState, 'triggerClickOnMarker');

        this.stopWatchingTriggerClickOnMarker = this.storeServ.subscribe(watchTriggerClickOnMarker((newPosCode, oldPosCode, objectPath) => {
            if (newPosCode) {
                this.posCode = newPosCode;

                this.getShopMarkersFromClusterer();

                this.findMarkerToClick();

                if (this.markerToClick) {
                    this.clickOnMarker();
                }
            }
        }));
    }

    getShopMarkersFromClusterer() {
        this.shopMarkers = this.markerClusterer.getMarkers();
    }

    findMarkerToClick() {
        this.markerToClick = this.shopMarkers.filter((marker) => {
            return marker.customProperties.shop.pos === this.posCode;
        })[0];
    }

    clickOnMarker() {
        google.maps.event.trigger(this.markerToClick, 'click');
    }

    ngOnDestroy() {
        this.stopWatchingTriggerClickOnMarker();
    }
}

ShopMarkerClickerCtrl.$inject = ['$scope', 'storeServ'];

var shopMarkerClicker = function() {
    return {
        restrict: 'E',
        scope: {},
        controllerAs: 'vm',
        controller: ShopMarkerClickerCtrl,
        bindToController: {
            markerClusterer: '='
        }
    };
};

export default shopMarkerClicker;
